/* ==========================================================================
   YEON ANIMATIONS & PRELOADER SCRIPT
   ========================================================================== */

// 1. PRELOADER ANIMATION TIMING
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const preloader = document.getElementById('preloader');
    if (!preloader) return;
    
    const MIN_MS = 2000;
    const start = Date.now();
    
    window.addEventListener('load', () => {
      const wait = Math.max(0, MIN_MS - (Date.now() - start));
      setTimeout(() => {
        preloader.classList.add('hide');
        setTimeout(() => preloader.remove(), 1100);
      }, wait);
    });
  });
})();

// 2. SCROLL REVEAL (INTERSECTION OBSERVER)
document.addEventListener('DOMContentLoaded', () => {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('[data-reveal]').forEach(el => revealObserver.observe(el));
});

// 3. KLAVIYO CUSTOM POPUP TRIGGER
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    const targetButton = event.target.closest('a, button, .button, .btn');
    
    if (targetButton && (targetButton.classList.contains('open-waitlist-btn') || targetButton.textContent.toLowerCase().includes('join the waitlist'))) {
      event.preventDefault(); // Stop page from jumping or redirecting
      
      // Open the custom theme-level Klaviyo waitlist popup
      if (typeof window.openYeonWaitlistModal === 'function') {
        window.openYeonWaitlistModal();
        console.log('Custom waitlist modal opened.');
      } else {
        // Fallback to Klaviyo built-in form
        const formId = window.yeonKlaviyoFormId || 'YOUR_FORM_ID';
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
        console.log('Klaviyo built-in form open triggered for ID:', formId);
      }
    }
  });
});
